export const TOGGLE_UPLOADED_BY =
  'album-folder-photos-filter/TOGGLE_UPLOADED_BY';
export const TOGGLE_ALBUM_ID = 'album-folder-photos-filter/TOGGLE_ALBUM_ID';
export const RESET_FILTER_BY_ID =
  'album-folder-photos-filter/RESET_FILTER_BY_ID';

export const albumFolderPhotosToggleUploadedBy = uploaderId => {
  return { type: TOGGLE_UPLOADED_BY, uploaderId };
};

export const albumFolderPhotosToggleAlbumId = albumId => {
  return { type: TOGGLE_ALBUM_ID, albumId };
};

export const albumFolderPhotosFilterResetById = albumFolderId => {
  return { type: RESET_FILTER_BY_ID, albumFolderId };
};
